var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export var VolumeOff = function VolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12 3.143a1 1 0 00-.124 1.408l14.141 16.853a1 1 0 001.532-1.285L4.53 3.266a1 1 0 00-1.41-.123zm.105 4.244h2.15l8.062 9.608v1.568a1.407 1.407 0 01-2.274 1.137l-5.336-4.09H3.225A1.223 1.223 0 012 14.385V8.612c0-.678.547-1.225 1.225-1.225zm12.608 6.24l1.335 1.591a4.697 4.697 0 001.825-3.72c0-1.487-.678-2.799-1.75-3.674a1.044 1.044 0 00-1.465.153c-.372.46-.285 1.116.175 1.487a2.63 2.63 0 01.962 2.034 2.61 2.61 0 01-1.071 2.122l-.01.008zm2.443 2.912l1.34 1.596.012-.01a8.482 8.482 0 003.17-6.604c-.021-2.69-1.246-5.075-3.17-6.627-.438-.35-1.072-.262-1.444.153-.35.437-.306 1.094.131 1.444 1.443 1.203 2.384 2.996 2.384 5.008a6.486 6.486 0 01-2.423 5.04zM8.726 5.157l4.711 5.615V4.413c0-1.16-1.355-1.838-2.295-1.116l-2.417 1.86z",
    fill: "currentColor"
  })));
};